
    <button
      type="button"
      class="fab border-0 shadow mt-2"
      data-bs-toggle="modal"
      data-bs-target="#select_sub_portals_modal"
    >
      +
    </button>
  <div class="modal fade" id="select_sub_portals_modal" tabindex="-1" aria-labelledby="selectPortalsLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <p class="modal-title text-xs fw-500" id="selectPortalsLabel">Select Sub-Portals</p>
          <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
  
        <form @submit.prevent="editPortal">
          <div class="modal-body">
  
            <!-- Portals Table -->
            <table class="table table-striped text-xs">
              <thead class="btn-primary text-white">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Portal Name</th>
                  <th scope="col">
                    Action 
                    <span class="ms-2">
                      <input  
                        class="form-check-input" 
                        type="checkbox" 
                        id="select_all_checkbox" 
                        :checked="areAllSubPortalsSelected" 
                      @change="toggleSelectAllSubPortals"
                      />
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody class="text-black">
                <tr v-for="(portal, index) in all_portals" :key="portal.id">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ portal.name }}</td>
                  <td>
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="checkbox" 
                        :id="'portal_check_' + portal.id" 
                        :value="portal.id" 
                        v-model="selectedPortals"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
  
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs shadow-sm rounded-3">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  